import {
    History, Person,
    Menu as Hamburger,
    People, Settings, ExitToApp,
    Add,
} from '@mui/icons-material';
import { getUserData, userSession, authenticatedUserAddress } from '../../services/auth';
import { clientNetwork } from '../../lib/constants';
import { GiWarPick, GiStoneStack } from 'react-icons/gi';
import { TbPencilPlus } from "react-icons/tb";
import { MdRocketLaunch } from "react-icons/md";
import { SlPuzzle } from "react-icons/sl";

// export const mainMenu = {
//     icon: <Hamburger />,
//     options: [
//         { name: 'Profile', value: 'profile/', icon: <Person /> },
//         { name: 'Contacts', value: 'contacts', icon: <People />, },
//         { name: 'History', value: 'history', icon: <History /> },
//         { name: 'Settings', value: 'settings', icon: <Settings /> },        
//         { name: 'Sign Out', value: 'signOut', icon: <ExitToApp /> },
//     ]
// }

//let userData; 
let principal;
if (userSession.isUserSignedIn()) {
    // userData = getUserData();
    // principal = getUserData().profile.stxAddress.testnet;
    principal = authenticatedUserAddress({ network: clientNetwork });
    console.log("p3 automagic networking: " + principal);
}
const principalProfilePath = `/${principal}`;

export const profileMenu = {
    icon: <Hamburger />,
    options: [
        { name: 'Profile', value: principalProfilePath, icon: <Person /> },
        // { name: 'Exhibit', value: 'exhibit', icon: <TbPencilPlus />, },
        { name: 'Mining', value: 'mining', icon: <GiWarPick />, },
        { name: 'Stacking', value: 'stacking', icon: <GiStoneStack />, },
        { name: 'Following', value: 'following', icon: <People />, },
        // { name: 'Launch', value: 'launch', icon: <MdRocketLaunch />, },
        { name: 'Extensions', value: 'extensions', icon: <SlPuzzle /> },
        { name: 'Settings', value: 'settings', icon: <Settings /> },
        { name: 'History', value: 'history', icon: <History /> },
        { name: 'Sign Out', value: 'signOut', icon: <ExitToApp /> },
    ]
}
export const FABMenu = {
    name: 'NewChime', value: 'new-chime', icon: <Add />
}

export const routeNameMapping = {

    '/following': 'Following',
    '/launch': 'Launch',
    '/exhibit': 'Exhibit',
    '/extensions': 'Extensions',
    '/profile/': 'Profile',
    '/rewards': 'Rewards',
    '/settings': 'Settings',
    '/mining': 'Mining',
    '/stacking': 'Stacking',
    '/history': 'History',
    '/proposals': 'Proposals',
    '/new-chime': 'NewChime',

}